import { render, staticRenderFns } from "./VillaRequestForm.vue?vue&type=template&id=cded06ca&scoped=true&"
import script from "./VillaRequestForm.vue?vue&type=script&lang=js&"
export * from "./VillaRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./VillaRequestForm.vue?vue&type=style&index=0&id=cded06ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cded06ca",
  null
  
)

export default component.exports